import React from 'react'
import {
  Box,
  TextField,
  ToggleButtonGroup,
  ToggleButton,
  InputAdornment,
} from '@mui/material'
import {
  Search as SearchIcon,
  Image as ImageIcon,
  VideoFile as VideoIcon,
  Description as DocumentIcon,
  AllInclusive as AllIcon,
} from '@mui/icons-material'

interface ContentFiltersProps {
  searchQuery: string
  onSearchChange: (query: string) => void
  contentType: string
  onContentTypeChange: (type: string) => void
  tagFilter: string
  onTagFilterChange: (tag: string) => void
  statusFilter: string
  onStatusFilterChange: (status: string) => void
}

const ContentFilters: React.FC<ContentFiltersProps> = ({
  searchQuery,
  onSearchChange,
  contentType,
  onContentTypeChange,
  tagFilter,
  onTagFilterChange,
  statusFilter,
  onStatusFilterChange,
}) => {
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, alignItems: 'center' }}>
      <TextField
        placeholder="Search by title..."
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        size="small"
        sx={{ flexGrow: 1, minWidth: 200 }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon color="action" />
            </InputAdornment>
          ),
        }}
      />

      <TextField
        placeholder="Filter by tag..."
        value={tagFilter}
        onChange={(e) => onTagFilterChange(e.target.value)}
        size="small"
        sx={{ width: { xs: '100%', md: 200 } }}
      />

      <Box sx={{ 
        width: { xs: '100%', md: 'auto' }, 
        overflowX: 'auto',
        '&::-webkit-scrollbar': { display: 'none' },
        msOverflowStyle: 'none',
        scrollbarWidth: 'none',
      }}>
        <ToggleButtonGroup
          value={contentType}
          exclusive
          onChange={(_, nextType) => onContentTypeChange(nextType === null ? contentType : nextType)}
          size="small"
          color="primary"
          sx={{ display: 'flex' }}
        >
          <ToggleButton value="" sx={{ whiteSpace: 'nowrap', px: { xs: 2, md: 2 } }}>
            <AllIcon sx={{ mr: 1 }} /> All
          </ToggleButton>
          <ToggleButton value="image" sx={{ whiteSpace: 'nowrap', px: { xs: 2, md: 2 } }}>
            <ImageIcon sx={{ mr: 1 }} /> Images
          </ToggleButton>
          <ToggleButton value="video" sx={{ whiteSpace: 'nowrap', px: { xs: 2, md: 2 } }}>
            <VideoIcon sx={{ mr: 1 }} /> Videos
          </ToggleButton>
          <ToggleButton value="document" sx={{ whiteSpace: 'nowrap', px: { xs: 2, md: 2 } }}>
            <DocumentIcon sx={{ mr: 1 }} /> Docs
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>
      <Box sx={{ 
        width: { xs: '100%', md: 'auto' }, 
        overflowX: 'auto',
      }}>
        <ToggleButtonGroup
          value={statusFilter}
          exclusive
          onChange={(_, nextStatus) => onStatusFilterChange(nextStatus === null ? statusFilter : nextStatus)}
          size="small"
          color="primary"
          sx={{ display: 'flex' }}
        >
          <ToggleButton value="" sx={{ whiteSpace: 'nowrap', px: 2 }}>All</ToggleButton>
          <ToggleButton value="active" sx={{ whiteSpace: 'nowrap', px: 2 }}>Active</ToggleButton>
          <ToggleButton value="inactive" sx={{ whiteSpace: 'nowrap', px: 2 }}>Inactive</ToggleButton>
        </ToggleButtonGroup>
      </Box>
    </Box>
  )
}

export default ContentFilters
